import * as React from 'react';
import * as ReactDOM from 'react-dom';

import KendoBaseComponent, { KendoWidgetProps } from '@progress/kendo-base-component-react-wrapper';

export interface EditorProps extends KendoWidgetProps, kendo.ui.EditorOptions {
    children?: React.ReactNode;
    value?: string;
}

export default class Editor extends KendoBaseComponent<EditorProps, {}> {
    componentDidMount(): void {
        const domNode = this.domNode;
        const { children, widgetRef, ...props } = this.props;

        if (domNode) {
            this.widgetInstance = new kendo.ui.Editor(domNode as Element, props);
            super.componentDidMount();
        }
    }

    render(): any {
        if (this.didMount) {
            const { children, widgetRef, ...props } = this.props;

            this.widgetInstance.setOptions(props);
            (this.widgetInstance as kendo.ui.Editor).value((props as any).value);
        }

        const domChild = React.Children
            .toArray(this.props.children)
            .shift();

        return domChild
            ? React.cloneElement(domChild, { ...domChild.props, ref: this.elementRef })
            : <textarea ref={this.elementRef} />;
    }
}



// WEBPACK FOOTER //
// ./packages/kendo-editor-react-wrapper/src/editor/index.tsx